import { login } from "@/api/login";
import { getToken, setToken, removeToken, setMenus, setUser, setMenusCheckKey } from "@/utils/auth";
import md5 from "js-md5";
import { Message } from "element-ui";
import { constantRouterMap } from "@/router";
import Layout from "@/views/layout/Layout.vue";

const KEFU_MENU_ICONS = {
  "/customer-service": "user",
  "/customer-service/knowledge": "newsCenter",
  "/customer-service/model": "equipmentManagement",
  "/customer-service/tools": "eye",
  "/customer-service/agents": "users"
};

function patchProductMenuIcon(item) {
  const name = item.name || "";
  const path = item.path || "";
  if (path.indexOf("sku-management") > -1) {
    item.icon = "table";
    return;
  }
  if (name.indexOf("\u8bc4\u8bba\u56de\u590d") > -1 || path.indexOf("reply") > -1) {
    item.icon = "form";
    return;
  }
  if (
    name.indexOf("\u5546\u54c1\u8bc4\u8bba") > -1 ||
    name.indexOf("\u8bc4\u8bba") > -1 ||
    path.indexOf("comment") > -1 ||
    path.indexOf("evaluate") > -1
  ) {
    item.icon = "content";
  }
}

function patchKefuMenuIcon(item) {
  if (item.name === "\u5ba2\u670d\u7cfb\u7edf") {
    item.icon = "user";
  }
  if (KEFU_MENU_ICONS[item.path]) {
    item.icon = KEFU_MENU_ICONS[item.path];
  }
}

function prepareMenuList(menuList = []) {
  const walk = list => {
    for (let index = list.length - 1; index >= 0; index -= 1) {
      const item = list[index];
      // Remove customer-service menus injected by older frontend builds. The
      // authorized menu must come from admin_permissions and the current role.
      if (item.id === "customer-service") {
        list.splice(index, 1);
        continue;
      }
      patchKefuMenuIcon(item);
      patchProductMenuIcon(item);
      if (item.children && item.children.length) {
        walk(item.children);
      }
    }
  };
  walk(menuList);
  return menuList;
}

/**
 * 閫掑綊鐢熸垚瀛愯彍鍗?
 */
function normalizeComponentPath(componentPath) {
  const path = (componentPath || "").trim();
  return path.startsWith("/") ? path : `/${path}`;
}

function createChildren(RouterMap, routerArr) {
  RouterMap.filter(item => {
    if (item.type === "MENU") {
      const itemRoute = {
        meta: { title: item.name, icon: item.icon ? item.icon.trim() : null },
        name: item.id + "" || "",
        path: (item.path && item.path.trim()) || "",
        component: () => import("@/views" + normalizeComponentPath(item.componentPath))
      };
      if (item.children && item.children.length) {
        const childrenRouterArr = [];
        createChildren(item.children, childrenRouterArr);
        itemRoute.children = childrenRouterArr;
      }
      routerArr.push(itemRoute);
    }
  });
}

function filterAsyncRouter(asyncRouterMap) {
  const routerArr = [];
  asyncRouterMap.filter(route => {
    if (route.parentId === 0) {
      let newRoute = {};
      // 澶氱骇
      if (route.children && route.children.length) {
        newRoute = {
          path: "",
          alwaysShow: true,
          component: Layout,
          meta: {
            icon: route.icon ? route.icon.trim() : null,
            title: route.name
          },
          name: route.name
        };
        const routerArr = [];
        createChildren(route.children, routerArr);
        newRoute.children = routerArr;
      } else {
        // 鍗曠骇
        newRoute = {
          path: "",
          component: Layout,
          name: "",
          children: [
            {
              path: route.path,
              name: route.name,
              meta: { title: route.name, icon: route.icon },
              component: () => import("@/views" + normalizeComponentPath(route.componentPath))
            }
          ]
        };
      }
      routerArr.push(newRoute);
    }
  });
  return routerArr;
}

const user = {
  state: {
    token: getToken(),
    username: "",
    avatar: "",
    roles: [],
    permissions: [],
    menus: [], // 鑿滃崟
    routers: [],
    addRouters: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, username) => {
      state.username = username;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus;
    },
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    }
  },

  actions: {
    // 鐧诲綍
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        const params = {
          username: userInfo.username.trim(),
          password: md5(userInfo.password),
          captchaKey: userInfo.captchaKey,
          captchaCode: userInfo.captchaCode
        };
        login(params)
          .then(response => {
            // response.bizcode === 101 && response.errcode === 109
            // response.bizcode === 101 && response.errcode === 109 璐﹀彿鎴栬€呭瘑鐮侀敊璇?
            if (
              (response.bizcode === 101 && response.errcode === 109) ||
              (response.bizcode === 201 && response.errcode === 202)
            ) {
              resolve(-2);
            } else {
              const data = response.data;
              setToken(data.token);
              commit("SET_TOKEN", data.token);
              const menus = prepareMenuList(data.menus || []);
              commit("SET_MENUS", menus);
              setMenus(menus);
              setMenusCheckKey(true);
              const user = {
                id: data.userId,
                name: data.name
              };
              setUser(user);
              resolve("ok");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 鑾峰彇鐢ㄦ埛淇℃伅
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { accessedRouters } = data;
        const accessedRoutersSum = filterAsyncRouter(prepareMenuList(accessedRouters));
        commit("SET_ROUTERS", accessedRoutersSum);
        resolve({ code: "ok", data: accessedRoutersSum });
      });
    },

    // 鐧诲嚭
    // LogOut({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     logout(state.token).then(() => {
    //       commit('SET_TOKEN', '')
    //       commit('SET_ROLES', [])
    //       removeToken()
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 鍓嶇 鐧诲嚭
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit("SET_TOKEN", "");
        commit("SET_MENUS", []);
        removeToken();
        resolve();
      });
    }
  }
};

export default user;
